import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  // getUserApplicationsService,
  getApplicationGroupsService,
  getApplicationsByGroupService,
  updateApplicationStatusService,
  getAppGroupPlaidResultsService,
  getApplicationGroupScreeningService,
  getPropertyUnitRentService,
  requestApplicationGroupScreeningService,
  updateAppGroupService,
  updateApplicationDataService,
  updateLeaseStatusService,
  getPropertyUnitsService,
  updateAppInfoService,
  getTransactionCategoriesService,
  saveLeaseDraftService,
  getLeasePreviewService,
  sendLeaseService,
  getApplicationGroupScreeningFromTUService,
  getPropertyFeeRecordService,
  getAdverseActionPreviewService,
  sendAdverseActionEmailsService,
  getAllPropertyUnitsService,
  refreshIDVForGroupService,
  getLeaseHistoryService,
  getCurrentLeaseService,
  createNewLeaseVersionService,
  splitApplicationFromGroupService,
} from '../../services/easyapp.service';
import { getScreeningRequestData } from './easyapp-utils';
import { config } from '../../utils/config';
import mockData from './mockApplicationsData';

/**
 * NOTE: token is not used in the service functions yet
 * Pending implementation in the credibuilder API
*/

export const asyncGetUserApplications = createAsyncThunk(
  'easyapp/applications/get',
  async () => {
    try {
      // const token = config.REACT_APP_CREDIBUILDER_SECRET;
      // const response: any = await getUserApplicationsService(token);

      return { data: mockData };
    } catch (error) {
      console.log(error);
    }
  }
);

export const asyncGetApplicationGroups = createAsyncThunk(
  'easyapp/application-groups/get',
  async (object_id: string) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await getApplicationGroupsService(token, object_id);

      return response.data;
    } catch (error) { }
  }
);

export const asyncGetApplicationsByGroup = createAsyncThunk(
  'easyapp/application-group/get',
  async (application_group: string) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await getApplicationsByGroupService(
        application_group,
        token
      );

      return response.data;
    } catch (error) {}
  }
);

export const asyncUpdateApplicationStatus = createAsyncThunk(
  'easyapp/applications/updateStatus',
  async ({
    status,
    application_group
  }: {
    status: string;
    application_group: string;
  }) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await updateApplicationStatusService(
        application_group,
        {
          status: status
        },
        token
      );

      return response.data;
    } catch (error) {}
  }
);

export const asyncUpdateAppInfoService = createAsyncThunk(
  'easyapp/applications/updateAppInfo',
  async ({
    fieldName,
    value,
    application_group,
    unitNumber,
    property_name
  }: {
      fieldName: string;
      value: string;
      application_group: string;
      unitNumber?: string;
      property_name?: string;
  }) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;

      let response: any
      if (fieldName === 'desired_apartment') {
        response = await updateAppInfoService(
          {
            fieldName: fieldName,
            value: value,
            appGroupId: application_group,
            unitNumber: unitNumber
          },
          token
        );
      } else {
        response = await updateAppInfoService(
          {
            fieldName: fieldName,
            value: value,
            appGroupId: application_group
          },
          token
        );
      }

      return { application_group, fieldName, value, unitNumber, property_name, response: response.data };
    } catch (error) {
      throw error;
    }
  }
);

export const asyncUpdateAppGroup = createAsyncThunk(
  'easyapp/applications/updateAppGroup',
  async ({
    fieldName,
    value,
    application_group
  }: {
    fieldName: string;
    value: any
    application_group: string;
  }) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await updateAppGroupService(
        application_group,
        {
          fieldName: fieldName,
          value: value,
        },
        token
      );

      // return response.data;
      return { fieldName, value, application_group, response: response.data };
    } catch (error) {
      throw error;
    }
  }
);

export const asyncUpdateLeaseStatus = createAsyncThunk(
  'easyapp/applications/updateLeaseStatus',
  async ({
    appGroupID, 
    status,
  }: {
    appGroupID: string, 
    status: string,
  }) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await updateLeaseStatusService(
        {
          appGroupID, status
        },
        token
      );

      // return response.data;
      return { appGroupID, status, response: response.data };
    } catch (error) {
      throw error;
    }
  }
);

export const asyncUpdateAppData = createAsyncThunk(
  'easyapp/applications/updateAppData',
  async ({
    fieldName,
    value,
    applicationId,
  }: {
    fieldName: string;
    value: string
    applicationId: string;
  }) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await updateApplicationDataService(
        {
          applicationId,
          fieldName: fieldName,
          value: value,
        },
        token
      );

      // return response.data;
      return { fieldName, value, applicationId, response: response.data };
    } catch (error) {
      throw error;
    }
  }
);

export const asyncGetAppGroupPlaidResults = createAsyncThunk(
  'easyapp/applicationGroup/plaidResults',
  async (application_group: string) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await getAppGroupPlaidResultsService(
        application_group,
        token
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncGetAppGroupScreeningRequestData = createAsyncThunk(
  'easyapp/applicationGroup/screeningRequestData',
  async (_, { getState }: any) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const appGroupData = getState().easyapp.selectedAppGroup;
      const plaidResults = getState().easyapp.selectedAppGroupPlaidResults;
      // const screening = getState().easyapp.selectedAppGroupScreening;

      // get unit rent
      const rentRes: any = await getPropertyUnitRentService(
        appGroupData.ms_property_id,
        appGroupData.desired_apartment, // resman unit ID
        token
      );

      // get screening data for the application group
      const screeningRequestData = await getScreeningRequestData(
        appGroupData,
        rentRes,
        plaidResults,
        // screening?.ApplicationNumber || undefined
      );

      return screeningRequestData;
    } catch (error) {}
  }
);

export const asyncRequestApplicationGroupScreening = createAsyncThunk(
  'easyapp/applicationGroup/requestScreening',
  async (data: any, { getState }: any) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const screening = getState()?.easyapp?.selectedAppGroupScreening;
      if (screening !== null && screening.ApplicationNumber) {
        const response: any = await requestApplicationGroupScreeningService(
          data,
          token,
          screening.ApplicationNumber
        );
        return response.data;
      }

      const response: any = await requestApplicationGroupScreeningService(
        data,
        token
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncGetApplicationGroupScreening = createAsyncThunk(
  'easyapp/applicationGroup/screening',
  async (application_group: string) => {
    try {
      const response: any = await getApplicationGroupScreeningService(
        application_group,
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncGetApplicationGroupScreeningFromTU = createAsyncThunk(
  'easyapp/applicationGroup/screeningTU',
  async ({ appGroupId, tuPropertyId, screeningId }: any) => {
    try {
      const response: any = await getApplicationGroupScreeningFromTUService(
        appGroupId,
        tuPropertyId,
        screeningId,
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncGetAllPropertyUnits = createAsyncThunk(
  'easyapp/resman/properties/units',
  async (property_id: string) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await getPropertyUnitsService(
        property_id,
        token
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncGetPropertyUnits = createAsyncThunk(
  'easyapp/resman/properties/units/all',
  async (property_id: string) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await getAllPropertyUnitsService(
        property_id,
        token
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncGetTransactionCategories = createAsyncThunk(
  'easyapp/resman/transactionCategories',
  async () => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await getTransactionCategoriesService(token);
      return response.data;
    } catch (error) {}
  }
);

export const asyncGetPropertyUnitRent = createAsyncThunk(
  'easyapp/resman/properties/unit/rent',
  async ({ id, unitId }: { id: string; unitId: string }) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;
      const response: any = await getPropertyUnitRentService(
        id,
        unitId,
        token
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncSaveLeaseDraft = createAsyncThunk(
  'easyapp/application_group/saveDraft',
  async ({leaseDraft, appGroupID}: any) => {
    try {
      const token = config.REACT_APP_CREDIBUILDER_SECRET;

      const response: any = await saveLeaseDraftService(
        leaseDraft,
        appGroupID,
        token
      );
      return leaseDraft;
    } catch (error) {
      throw error;
    }
  }
);

export const asyncGetLeasePreview = createAsyncThunk(
  'easyapp/resman/generate-lease-pdf',
  async (selectedAppGroup: any) => {
    try {
      const response: any = await getLeasePreviewService(
        selectedAppGroup
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncSendLease = createAsyncThunk(
  'easyapp/docusign/send-for-signing',
  async (formData: FormData) => {
    try {
      const response: any = await sendLeaseService(formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const asyncgetPropertyFeeRecord = createAsyncThunk(
  'easyapp/properties/property/:id',
  async (id: string) => {
    try {
      const response: any = await getPropertyFeeRecordService(
        id
      );
      return response.data;
    } catch (error) {}
  }
);

export const asyncGetAdverseActionPreview = createAsyncThunk(
  'easyapp/adverse-action/generate-preview',
  async (formData: any) => {
    try {
      const response = await getAdverseActionPreviewService(formData);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

export const asyncSendAdverseActionEmails = createAsyncThunk(
  'easyapp/adverse-action/send-emails',
  async (formData: FormData) => {
    try {
      const response = await sendAdverseActionEmailsService(formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const asyncRefreshIDVForGroup = createAsyncThunk(
  'easyapp/plaid/refresh-idv-group',
  async (appGroupId: string) => {
    try {
      const response: any = await refreshIDVForGroupService(appGroupId);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

/* ============================================
 * LEASE VERSIONING ASYNC THUNKS
 * ============================================ */

export const asyncGetLeaseHistory = createAsyncThunk(
  'easyapp/application-group/lease-history',
  async (applicationGroupId: string) => {
    try {
      const response: any = await getLeaseHistoryService(applicationGroupId);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const asyncGetCurrentLease = createAsyncThunk(
  'easyapp/application-group/current-lease',
  async (applicationGroupId: string) => {
    try {
      const response: any = await getCurrentLeaseService(applicationGroupId);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const asyncCreateNewLeaseVersion = createAsyncThunk(
  'easyapp/application-group/new-lease-version',
  async ({ applicationGroupId, createdByUserId }: { applicationGroupId: string; createdByUserId?: string }) => {
    try {
      const response: any = await createNewLeaseVersionService(applicationGroupId, createdByUserId);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

/* ============================================
 * SPLIT APPLICATION ASYNC THUNKS
 * ============================================ */

/**
 * Split an application from its group into a new application group
 * Use case: Co-applicant decides not to proceed or needs separate processing
 */
export const asyncSplitApplication = createAsyncThunk(
  'easyapp/application-group/split',
  async (payload: {
    sourceGroupId: string;
    applicationId: string;
    archive: boolean;
  }) => {
    try {
      const response: any = await splitApplicationFromGroupService(payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);